declare const window: WindowTypes;

export const initFacebookSDK = (): Promise<void> => {
  return new Promise((resolve) => {
    // Load the SDK asynchronously
    if (typeof window !== 'undefined') {
      window.fbAsyncInit = function () {
        window.FB.init({
          appId: process.env.FACEBOOK_CLIENT_ID!,
          cookie: false,
          xfbml: true,
          version: process.env.FACEBOOK_GRAPH_API_VERSION!,
        });
        resolve();
      };

      // Load SDK script
      (function (d, s, id) {
        const fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        const js = d.createElement(s) as HTMLScriptElement;
        js.id = id;
        js.src = 'https://connect.facebook.net/en_US/sdk.js';
        fjs.parentNode?.insertBefore(js, fjs);
      })(document, 'script', 'facebook-jssdk');
    }
  });
};

export const loginWithFacebook = () => {
  return new Promise((resolve, reject) => {
    window.FB.login((response) => {
      if (response.authResponse) {
        resolve(response);
      } else {
        reject(new Error('User cancelled login or did not fully authorize.'));
      }
    }, { scope: 'email,public_profile' });
  });
};